import Controller from '../model/Controller';
import GigyaManager from "../business/GigyaManager";
import $ from "jquery";

class SpecialitaCasaCtrl extends Controller {
    constructor(element) {
        super(element);
        this.$el = $(this.element);
        this.init();
        this.piccoloMugnaioBiancoCH = "CH_1071_MLB_WEB_SPECIALITACASA_NAV_NAV_20250313_20250328";
        this.regSource = 1071;

        this.dataVideoGallery = [
            {videoId: 'YSHKvGPbUBs'},
            {videoId: 'I3JbS-5-K2c'},
            {videoId: 'x3sYgiVWpR0'},
            {videoId: '0nbZtOuOO9I'}
        ];

        let tag = document.createElement('script');
        tag.src = "https://www.youtube.com/iframe_api";
        let firstScriptTag = document.getElementsByTagName('script')[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

        this.players = [];

        let playerElements = [];
        $('.specialitaCasa__video-main').each((index, obj) => {
            let thisId = $(obj).attr('id');

            if (!thisId) {
                thisId = `player${index}`;
                $(obj).attr('id', thisId);
            }

            playerElements.push({
                id: thisId,
                index: index
            });
        });

        window.onYouTubeIframeAPIReady = () => {
            playerElements.forEach(({id, index}) => {
                this.players[index] = new YT.Player(id, {
                    height: '100%',
                    width: '100%',
                    videoId: this.dataVideoGallery[index].videoId,
                    controls: 2,
                    events: {
                        onReady: (event) => {
                            this.onReady(event);
                        },
                        onStateChange: (event) => {
                            this.onPlayerStateChange(event, id);
                        }
                    }
                });
            });
        };

    }

    onReady(event) {
    }

    onPlayerStateChange(event, id) {
        if (event.data == 5) {
            this.players[id].playVideo();
        } else if (event.data == 0) {
            $($('.cover')[id]).show();
        }
    }

    playOrChange(id) {
        $($('.cover')[id]).hide();
        this.players[id].loadVideoById(this.dataVideoGallery[id]);
    }

    init() {
        $('#overlayer').show();
        GigyaManager.getLoggedUser().then((user) => {
            const ch = user.data[this.piccoloMugnaioBiancoCH];
            if (typeof ch !== "undefined" && ch != null && ch !== "") {
                this.showLoggedArea(true);
            } else {
                this.showLoggedArea(false);
            }
        }, () => {
            this.showLoggedArea(false);
        });
    }

    showLoggedArea(canUser) {
        $(`.promo-${canUser}`).addClass('check');
        $('#overlayer').hide();
    }
}

export default SpecialitaCasaCtrl;